import store from '../../redux/store';
import { get_settings } from '../api/Users';
import { normalize_roles } from '../../helpers/hasRole';
import { read_has_live_keycloak_session } from './session_tokens';

export const expireSession = () => {
    store.dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('persistantState');
};

export const get_user_settings_from_database_and_save_user_to_cache = async(keycloak, user) => {
    const sessionToken = keycloak.token;
    let data = false;

    try {
        data = await get_settings(user.sub);
    } catch (error) {
        data = false;
    }

    const currentSession = store.getState()?.user;
    if (
        currentSession?.user?.sub !== user.sub
        || currentSession?.token !== sessionToken
        || keycloak.token !== sessionToken
        || !read_has_live_keycloak_session(keycloak, currentSession?.user, currentSession?.token)
    ) {
        return false;
    }

    const userSettings = data?.data || {};
    const settingsRoles = normalize_roles(userSettings);
    const keycloakRoles = normalize_roles(user);
    const roles = settingsRoles.length ? settingsRoles : keycloakRoles;
    const newUser = {
        ...user,
        ...userSettings,
        roles,
        rolesResolved: true
    };

    store.dispatch({
        type: 'SET_USER',
        payload: newUser
    });

    store.dispatch({
        type: 'SET_TOKEN',
        payload: keycloak.token
    });

    return newUser;
};
